import { BetSlipPurchaseType } from '@core/models/shared/betSlip/betSlipEnums';
import config from '@config';
import ILottoBetSlipState from './types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters/index';
import { EMPTY_PAYOUT } from '@core/models/betSlip/Payout';

const defaultState = {
    selections: [],
    candidateSelection: null,
    undoSelections: null,
    undoStake: null,
    undoSelectedSystems: null,
    undoSelectionTimerId: null,
    selectedSystems: {},
    stake: null,
    payout: EMPTY_PAYOUT,
    isPayoutLocked: false,
    maxSystems: config.app.lottoBetSlip.maxSystems,
    maxSelections: config.app.lottoBetSlip.maxSelections,
    purchaseType: BetSlipPurchaseType.offline,
    error: null,

    event: null,
} as ILottoBetSlipState;

export default {
    actions,
    mutations,
    getters,
    state: defaultState,
    namespaced: true,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/index.ts